<div class="breadcrumb">
  @for (item of breadcrumb(); track $index) {
    @if (!item.isCurrentPage) {
      <a [routerLink]="item.link">
        {{ item.text }}
      </a>
      <app-svg src="/assets/icons/chevron-right.svg"> </app-svg>
    }
  }
</div>
